var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-top"},[_c('p',{staticClass:"title"},[_vm._v("课件平台")]),_c('div',{staticClass:"btns-box"},[(_vm.$route.query.id && _vm.isBack)?_c('p',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("返回")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }